import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </M>
  );
};

export const SectionLabel = ({ children, dark = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] flex items-center gap-3 ${dark ? "text-[#0f766e]" : "text-[#2DD4BF]"}`}>
    <span className={`h-px w-10 ${dark ? "bg-[#0f766e]" : "bg-[#2DD4BF]"}`} />
    {children}
  </p>
);
